import React from 'react';
import { Modal } from '@spotify-internal/anchor-ds';
import {
  ButtonTertiary,
  LogoSpotify,
  spacer4,
  spacer24,
} from '@spotify-internal/encore-web';
import styled from 'styled-components';
import { useT } from 'i18n/hooks/useT';
import { SpotifyConnectButton } from './SpotifyConnectButton';

type SpotifyConnectInitialModalProps = {
  onConnectSpotify: () => void;
  onClose: () => void;
};

const PaddedTitleText = styled.div`
  margin-top: ${spacer24};
`;

const ModalActionWrapper = styled.div`
  padding-bottom: ${spacer4};
`;

export const SpotifyConnectInitialModal = ({
  onConnectSpotify,
  onClose,
}: SpotifyConnectInitialModalProps) => {
  const t = useT();

  return (
    <Modal
      isShowingCloseButton
      onClose={onClose}
      aria-labelledby="spotify-connect-initial-modal-title"
    >
      <Modal.Title id="spotify-connect-initial-modal-title">
        <LogoSpotify height={124} width={124} condensed useBrandColor={true} />
        <PaddedTitleText>
          {t(
            'SpotifyConnectInitialModal.Title',
            'Link your Spotify account',
            'Spotify Link Initialization Modal Title'
          )}
        </PaddedTitleText>
      </Modal.Title>
      <Modal.Body>
        {t(
          'SpotifyConnectInitialModal.Body',
          'Unlock new ways of earning, get insights about your listeners and add music from your playlists to episodes.',
          'Spotify Link Initialization message'
        )}
      </Modal.Body>
      <Modal.Footer>
        <ModalActionWrapper>
          <SpotifyConnectButton onConnectSpotify={onConnectSpotify} />
        </ModalActionWrapper>
        <ButtonTertiary semanticColor="textBrightAccent" onClick={onClose}>
          {t(
            'SpotifyConnectInitialModal.MaybeLaterLabel',
            'Maybe Later',
            'Exit modal text'
          )}
        </ButtonTertiary>
      </Modal.Footer>
    </Modal>
  );
};
